
export const BotIcon: React.FC = () => {
  return (
    <>
      <path
        fill="#fff8b8"
        d="M8.38-17.08c19.36 0 35.1 10.28 35.1 22.91v4.5C43.48 20.6 33 25 8.38 25H-8.38c-24.6 0-35.1-4.38-35.1-14.65V5.83c0-12.63 15.74-22.91 35.1-22.91H8.38m0-1H-8.38c-19.91 0-36.1 10.73-36.1 23.91v4.5C-44.48 23.52-28.29 26-8.38 26H8.38c19.91 0 36.1-2.46 36.1-15.65V5.83c0-13.18-16.19-23.91-36.1-23.91z"
      />
      <path
        fill="none"
        stroke="#fff8b8"
        strokeWidth="2"
        d="M-16.53 1.43a8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8 8 8 0 018 8zm39-8a8 8 0 108 8 8 8 0 00-8-8z"
      />
      <path
        fill="none"
        stroke="#fff8b8"
        strokeWidth="3"
        d="M17.86-28.89a10.81 10.81 0 0110.41-7.9A10.81 10.81 0 0139.08-26a10.66 10.66 0 01-1.23 5m24.51 45.25a54 54 0 00-54-54H-8.38a54 54 0 00-54 54v2c2.58 6 24.43 10.57 50.61 10.57h23.5c26.14 0 48-4.59 50.61-10.55z"
      />
    </>
  );
};
